import React, { useState } from "react";
import { CustomLink } from "data/types";
import "./footer.css";
import { useOnlineOrderSettings } from "context/OnlineOrderSettingsContext";
import TermsAndConditionsContent from "./TermsAndConditionsContent";
export interface WidgetFooterMenu {
  id: string;
  title: string;
  menus: CustomLink[];
}

const Footer: React.FC = () => {
  const [popupContent, setPopupContent] = useState(null);
  const { settings } = useOnlineOrderSettings();
  const openPopup = (content: any) => {
    setPopupContent(content);
  };

  const closePopup = () => {
    setPopupContent(null);
  };


  return (
    <div className="z-40 border-t border-slate-200 dark:border-slate-700 mb-1 pb-1 bg-white dark:bg-slate-800">
    <div className="container w-full flex flex-col md:flex-row justify-between items-center">
      <div className="col-span-2 md:col-span-1 flex flex-col items-start">
        <div className="mt-1 mb-1">
          <p className="text-sm text-gray-500 dark:text-gray-100">
            Contact Info:{" "}
            <a
              href={`tel:${settings?.phn}`}
              className="text-blue-500 hover:underline whitespace-nowrap"
            >
              {settings?.phn}
            </a>
          </p>
        </div>
      </div>
  
      <div className="col-span-2 md:col-span-1 flex flex-col items-end">
        <div className="mt-1 mb-1 flex items-center space-x-1">
          <button
            className="text-sm text-gray-500 dark:text-gray-100"
            onClick={() => openPopup("privacy")}
          >
            Privacy Policy
          </button>
          <span className="text-gray-500">|</span>
          <button
            className="text-sm text-gray-500 dark:text-gray-100"
            onClick={() => openPopup("terms")}
          >
            Terms & Conditions
          </button>
          <span className="text-gray-500">|</span>
          <button
            className="text-sm text-gray-500 dark:text-gray-100"
            onClick={() => openPopup("refund")}
          >
            Refund Policy
          </button>
        </div>
      </div>
    </div>
 
  

      {popupContent && (
        <div className="popup-overlay" onClick={closePopup}>
          <div
            className="popup policy-modal dark:bg-slate-800"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label={
              popupContent === "privacy"
                ? "Privacy policy"
                : popupContent === "terms"
                  ? "Terms and conditions"
                  : "Refund policy"
            }
          >
            {popupContent === "privacy" && (
           <>
  <div className="border-b border-slate-200 dark:border-slate-600 pb-4 mb-4">
    <h2 className="font-bold text-lg md:text-xl text-slate-900 dark:text-slate-100">
      Privacy Policy
    </h2>
    <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">Last updated: July 2024</p>
  </div>
  <p className="text-sm md:text-base text-slate-700 dark:text-slate-200 leading-relaxed">
    Information that is gathered from visitors: In common with other websites,
    log files are stored on the web server saving details such as the visitor's IP address, browser type,
    referring page, and time of visit. Cookies may be used to remember visitor preferences when interacting
    with the website.

    Where registration is required, the visitor's email and a username will be stored on the server.

    <br /><br />

    <strong>How the Information is used:</strong> The information is used to enhance the visitor's experience
    when using the website to display personalised content and possibly advertising. E-mail addresses will not
    be sold, rented, or leased to third parties. E-mail may be sent to inform you of news of our services or
    offers by us or our affiliates.

    <br /><br />

    <strong>Visitor Options:</strong> If you have subscribed to one of our services, you may unsubscribe by
    following the instructions included in the email you receive. You may be able to block cookies via your
    browser settings but this may prevent access to certain features.

    <br /><br />

    <strong>Cookies:</strong> Cookies are small digital signature files that are stored by your web browser
    that allow your preferences to be recorded when visiting the website. They may also be used to track your
    return visits. Third-party advertising companies may also use cookies for tracking purposes.

    <br /><br />

    <strong>Google Ads:</strong> Google, as a third-party vendor, uses cookies to serve ads. Google's use of
    the DART cookie enables it to serve ads based on your visit to various websites. You can opt out of the
    DART cookie by visiting the Google ad and content network privacy policy.
  </p>
</>

            )}
            {popupContent === "terms" && <TermsAndConditionsContent />}
            {popupContent === "refund" && (
              <>
                <div className="border-b border-slate-200 dark:border-slate-600 pb-4 mb-4">
                  <h2 className="font-bold text-lg md:text-xl text-slate-900 dark:text-slate-100">
                    Refund Policy
                  </h2>
                </div>
                <p className="text-sm md:text-base text-slate-700 dark:text-slate-200 leading-relaxed">
                  All sales are final once an order has been submitted and
                  prepared by the restaurant. Customers may request a
                  cancellation or refund only if the order has not yet entered
                  preparation. Once food preparation has begun, the order cannot
                  be canceled or refunded.
                  <br /><br />
                  If a refund is approved, it will be issued to the original
                  form of payment used at checkout. Approved refunds are
                  typically processed within 5–10 business days, depending on the
                  customer's financial institution.
                  <br /><br />
                  <strong>Refunds will not be issued for:</strong>
                  <br />
                  · Orders that have already been prepared
                  <br />
                  · Orders that have been picked up or delivered
                  <br />
                  · Customer errors, including incorrect items selected or
                  incorrect delivery information
                  <br />
                  · Delays or issues caused by third-party delivery services
                  <br /><br />
                  In the event of an incorrect, incomplete, or unsatisfactory
                  order, customers must contact the restaurant directly. Refund
                  decisions are made at the restaurant's discretion.
                  <br /><br />
                  Delivery fees, service fees, and processing fees are
                  non-refundable.
                </p>
              </>
            )}
          <div className="flex justify-center md:justify-end mt-6 pt-4 border-t border-slate-200 dark:border-slate-600">
            <button
              type="button"
              onClick={closePopup}
              className="inline-flex items-center justify-center rounded-xl bg-primary-500 px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 dark:focus:ring-offset-slate-800"
            >
              Close
            </button>
          </div>

          </div>
        </div>
      )}
    </div>
  );
};

export default Footer;
